const constants = {
    maxTagLength: 20
}

export default constants